module.exports = __webpack_public_path__ + "static/what-it-takes-95369add7477b6b1b287d9c27d633ec6.jpg";